import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { ArrowRightOutlined } from '@ant-design/icons';
import s from '../../s.module.less';

interface IJumpNodeData {
    label?: string;
    type: 'jump';
    targetQuestionId?: string;
    targetQuestionTitle?: string;
}

const JumpNode: React.FC<NodeProps<IJumpNodeData>> = ({ data, selected }) => {
    return (
        <div className={`${s.jumpNode} ${selected ? 'selected' : ''}`}>
            <Handle
                type="target"
                position={Position.Left}
                id="left"
                style={{ background: '#722ed1' }}
            />
            <Handle
                type="source"
                position={Position.Right}
                id="right"
                style={{ background: '#722ed1' }}
            />
            <div className={s.nodeContent}>
                <ArrowRightOutlined className={s.nodeIcon} />
                <div className={s.nodeLabel}>
                    {data.label || 'Jump'}
                </div>
                {data.targetQuestionTitle && (
                    <div className={s.nodeSubLabel}>
                        To: {data.targetQuestionTitle}
                    </div>
                )}
            </div>
        </div>
    );
};

export default JumpNode;
